<template>
    <div>
        <div class="dropdown">
            <span class="text-green-foundation" v-if="contact.sage_cre_customer_no">Contact synced with Sage 300</span>

            <button type="button" :disabled="isLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="agaveOptionDropDown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i v-if="isLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                Sage 300 Options <i class="fa fa-caret-down mx-1"></i>
            </button>
            <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="agaveOptionDropDown">
                <button v-if="canErpCreate" type="button" class="dropdown-item py-2"
                    :disabled="contactMapping.direction === 'one-way-followup' || contact.sage_cre_customer_no"
                    @click.prevent.stop="syncContactToAgave">
                    Connect/Push to Sage 300
                </button>
                <button v-if="canErpUpdate" type="button" class="dropdown-item py-2"
                    :disabled="contactMapping.direction === 'one-way-followup' || !contact.sage_cre_customer_no"
                    @click.prevent.stop="syncContactToAgave">
                    Update Customer on Sage 300
                </button>
                <button v-if="canErpSync" type="button" class="dropdown-item py-2"
                    :disabled="contactMapping.direction === 'one-way-third-party'" @click.prevent="syncFromAgave()">
                    Sync from Sage 300
                </button>
            </div>
        </div>


        <div class="modal" tabindex="-1" role="dialog" id="updateAgaveCustomerModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of an
                            existing Sage 300 Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{modalBody}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                            class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none"
                            @click.prevent="closeModal('updateAgaveCustomerModal')">Cancel</button>
                        <button type="button" class="btn btn-primary"
                            @click.prevent="updateCustomerToAgave()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" tabindex="-1" role="dialog" id="syncAgaveWarningModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write some of the
                            contact info.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this contact with info form the Sage 300 customer.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                            class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none"
                            @click.prevent="closeModal('syncAgaveWarningModal')">Cancel</button>
                        <button type="button" class="btn btn-primary"
                            @click.prevent="closeModal('syncAgaveWarningModal'); saveSyncedAgaveCustomer()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectAgaveCustomerModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">This contact is not synced with a Sage 300
                            Customer
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click="closeModal('selectAgaveCustomerModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Sage 300 customer to sync with</label>
                                <div v-if="fetchingAgaveCustomers" class="spinner text-sm text-teal">
                                    Fetching customers from Sage 300...
                                </div>
                                <multiselect
                                    v-model="selectedAgaveCustomer"
                                    :options="customersFromAgave"
                                    @search-change="searchContacts"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Searching Sage 300 customer..."
                                    :loading="fetchingAgaveCustomers"
                                    :closeOnSelect="true">
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                            class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none"
                            @click.prevent.stop="closeModal('selectAgaveCustomerModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" :disabled="!selectedAgaveCustomer"
                            @click.prevent="saveSyncedAgaveCustomer">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect';
    export default {
        name: 'sage-300-contact',
        props: ['company', 'contact', 'user', 'team', 'contactMapping', 'customCustomerCodeFieldId', 'customContactCodeFieldId', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
        components: {Multiselect},
        data() {
            return {
                isLoading: false,
                modalBody: '',
                customersFromAgave: [],
                selectedAgaveCustomer: null,
                fetchingAgaveCustomers: false,
                customContactCode: null,
                customCustomerCode: null,
            }
        },
        mounted() {
        },
        watch: {
            // 'form.user': function (value) {
            //     this.contact.last_meeting.user = value;
            //     Bus.$emit('changeUserFormContact', value);
            // }
        },
        created() {
            this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
        },
        computed: {
            // mailSubject() {
            //     return `?subject=(${this.form.name} - ${this.contact.id})`;
            // },
        },
        methods: {
            syncContactToAgave() {
                let self = this;

                if (self.contact.sage_cre_customer_no) {
                    self.modalBody = 'This will replace some of the customer info on the Sage 300 Customer record. Are you sure you want to update the customer on Sage 300?';
                    self.openModal('updateAgaveCustomerModal');
                } else {
                    this.pushContactToAgave();
                }
            },
            checkContactCustomCode(){
                if(this.customContactCodeFieldId){
                    let contactCode = this.getSafe(() => this.$parent.$refs.ContactCustomFields.form[this.customContactCodeFieldId]);
                    if(contactCode){
                        if(contactCode.length <= 3){
                            this.customContactCode = contactCode;
                            return true;
                        }else{
                            this.getToast().fire({
                                type: 'error',
                                title: 'Invalid Contact Code: must not be greater than 3 characters'
                            });
                            return false;
                        }
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Sage 300 Contact Code is required'
                        });
                        return false;
                    }
                }
                return true;
            },
            checkCustomerCustomCode(){
                if(this.customCustomerCodeFieldId){
                    let customerCode = this.getSafe(() => this.$parent.$refs.ContactCustomFields.form[this.customCustomerCodeFieldId]);
                    if(customerCode){
                        if(customerCode.length <= 5){
                            this.customCustomerCode = customerCode;
                            return true;
                        }else{
                            this.getToast().fire({
                                type: 'error',
                                title: 'Invalid Customer Code: must not be greater than 5 characters'
                            });
                            return false;
                        }
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Sage 300 Customer Code is required'
                        });
                        return false;
                    }
                }
                return true;
            },

            pushContactToAgave() {
                if(!this.checkContactCustomCode() || !this.checkCustomerCustomCode()){
                    return false;
                }
                let self = this;
                let payload = {
                        'contact_id': self.contact.id,
                        'customCustomerCode' : this.customCustomerCode,
                        'customCustomerCodeFieldId' : this.customCustomerCodeFieldId,
                        'customContactCode' : this.customContactCode,
                        'customContactCodeFieldId' : this.customContactCodeFieldId
                    };
                    self.isLoading = true;
                    axios.post(route('api.sage300.connect-residential-customer-and-contact-on-agave'), payload).then((response) => {
                        self.isLoading = false;

                        if (response.data.status === 'success') {
                            self.getToast(3000).fire({ type: 'success', title: response.data.message });
                            setTimeout(() => {
                                window.location.reload();
                            }, 3000);

                        } else {
                            self.getToast().fire({ type: 'error', title: response.data.message });
                        }
                    });
            },
            openModal(modalId) {
                $('#' + modalId).modal('show');
            },

            closeModal(modalId) {
                $('#' + modalId).modal('hide');
            },

            updateCustomerToAgave() {
                let self = this;
                let payload = { 'contact_id': this.contact.id };
                self.isLoading = true;
                self.closeModal('updateAgaveCustomerModal');
                axios.post(route('api.sage300.update-residential-customer-on-agave'), payload).then((response) => {

                    self.isLoading = false;

                    if (response.data.status == 'success') {
                        self.getToast(3000).fire({
                            type: 'success',
                            title: response.data.message
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);

                    } else {
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            },

            syncFromAgave() {
                if (this.contact.sage_cre_customer_no) {
                    this.openModal('syncAgaveWarningModal');
                } else {
                    this.openModal('selectAgaveCustomerModal');
                }
            },

            searchContacts(value) {
                if (value.length >= 3) {
                    this.fetchingAgaveCustomers = true;
                    this.debouncedFilterOptions(value);
                }
            },

            filterOptions(input) {
                let self = this;
                axios.post(route('api.sage300.fetch-customers-from-agave'), { search: input }).then((response) => {
                    self.fetchingAgaveCustomers = false;
                    if (response.data.status == 'success') {
                        self.customersFromAgave = response.data.customers;
                    } else {
                        self.getToast().fire({ type: 'error', title: response.data.message });
                    }
                });
            },

            saveSyncedAgaveCustomer() {
                if(this.selectedAgaveCustomer && this.customContactCodeFieldId && !this.checkContactCustomCode()){  // if Contact code is set to customField and Syncing with customer
                    return false;
                }
                let self = this;
                let payload = {
                    connect_with_customer_id: this.selectedAgaveCustomer ? this.selectedAgaveCustomer : null,
                    contactId: this.contact.id,
                    customContactCode : this.customContactCode,
                    customContactCodeFieldId : this.customContactCodeFieldId
                }
                self.isLoading = true;
                self.closeModal('selectAgaveCustomerModal');
                axios.post(route('api.sage300.sync-residential-customer-and-contacts-from-agave-to-followup'), payload).then((response) => {
                    self.isLoading = false;
                    if (response.data.status == 'success') {
                        // self.company.sage_cre_customer_no = response.data.agave_customer_id
                        // self.company.agave_customer_no = response.data.agave_customer_no
                        self.getToast(3000).fire({ type: 'success', title: response.data.message });
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    } else {
                        self.getToast().fire({ type: 'error', title: response.data.message });
                    }
                });

            },

        },
    }
</script>
